import { DashboardModule } from '@domain-group/suit-theme'

import useProcessChecklist from '../../hooks/useProcessChecklist'

import TaskListItem from './TaskListItem'

interface TaskListItemsProps {
  processChecklistPayload: ReturnType<typeof useProcessChecklist>,
}

const TaskListItems = (props: TaskListItemsProps) => {
  const {
    processChecklistPayload: {
      taskListPayload: {
        loading,
      },
      taskListItemsPayload: { filteredTaskListItems },
    },
  } = props

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} loading={loading} title="Checklist Items">
      {filteredTaskListItems.map(taskListItem => (
        <TaskListItem key={taskListItem.id} taskListItem={taskListItem} />
      ))}
    </DashboardModule>
  )
}

export default TaskListItems
